import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import { grindSchema } from "../../Validation/Validation";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import ImageUploadDragAndDrop from "../../Components/ImageUploadDragAndDrop";
import Breadcrumb from "../../Components/Breadcrumb";

const AddGrind = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    grindName: editData?.grindName,
    thumbnailImage: editData?.thumbnailImage,
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive ?? false,
  };
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: grindSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("grindName", values.grindName || "");
        formData.append("sortOrder", values.sortOrder);
        formData.append("isActive", values.isActive || false);
        if (values.thumbnailImage instanceof File) {
          formData.append("thumbnailImage", values.thumbnailImage);
        }

        const response = editingId
          ? await axiosInstance.put(`/grind/updateGrind/${editingId}`, formData)
          : await axiosInstance.post("/grind/createGrind", formData);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/grinds");
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Grinds", path: "/grinds" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Grind
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="grind-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="grind-sortOrder"
                        name="sortOrder"
                        placeholder="Enter Grind Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="grindName" className="col-form-label ">
                        Name
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="grindName"
                        name="grindName"
                        placeholder="Enter grind name"
                        value={values.grindName || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.grindName && errors.grindName && (
                        <small className="text-danger">
                          {errors.grindName}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <ImageUploadDragAndDrop
                      id="grind-thumbnailImage"
                      label={`Grind Image`}
                      value={values.thumbnailImage}
                      onChange={(file) => setFieldValue("thumbnailImage", file)}
                      error={errors.thumbnailImage}
                      touched={touched.thumbnailImage}
                    />
                  </div>
                  <div className="col-md-6 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/grinds">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddGrind;
